"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MedusaConnectionError = exports.MedusaPermissionError = exports.MedusaAuthenticationError = exports.MedusaAPIError = exports.MedusaInvalidRequestError = void 0;
/**
 * MedusaError is the base error for every other MedusaError
 */
var MedusaError = /** @class */function (_super) {
  __extends(MedusaError, _super);
  function MedusaError() {
    return _super.call(this) || this;
  }
  MedusaError.factory = function (type) {
    switch (type) {
      case ErrorType.INVALID_REQUEST:
        return new MedusaInvalidRequestError();
      case ErrorType.AUTHENTICATION:
        return new MedusaAuthenticationError();
      case ErrorType.API:
        return new MedusaAPIError();
      case ErrorType.PERMISSION:
        return new MedusaPermissionError();
      case ErrorType.CONNECTION:
        return new MedusaConnectionError();
    }
  };
  return MedusaError;
}(Error);
exports.default = MedusaError;
var ErrorType;
(function (ErrorType) {
  ErrorType[ErrorType["INVALID_REQUEST"] = 0] = "INVALID_REQUEST";
  ErrorType[ErrorType["API"] = 1] = "API";
  ErrorType[ErrorType["AUTHENTICATION"] = 2] = "AUTHENTICATION";
  ErrorType[ErrorType["PERMISSION"] = 3] = "PERMISSION";
  ErrorType[ErrorType["CONNECTION"] = 4] = "CONNECTION";
})(ErrorType || (ErrorType = {}));
/**
 * MedusaInvalidRequestError is raised when a request as invalid parameters.
 */
var MedusaInvalidRequestError = /** @class */function (_super) {
  __extends(MedusaInvalidRequestError, _super);
  function MedusaInvalidRequestError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return MedusaInvalidRequestError;
}(MedusaError);
exports.MedusaInvalidRequestError = MedusaInvalidRequestError;
/**
 * MedusaAPIError is raised in case no other type cover the problem
 */
var MedusaAPIError = /** @class */function (_super) {
  __extends(MedusaAPIError, _super);
  function MedusaAPIError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return MedusaAPIError;
}(MedusaError);
exports.MedusaAPIError = MedusaAPIError;
/**
 * MedusaAuthenticationError is raised when invalid credentials is used to connect to Medusa
 */
var MedusaAuthenticationError = /** @class */function (_super) {
  __extends(MedusaAuthenticationError, _super);
  function MedusaAuthenticationError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return MedusaAuthenticationError;
}(MedusaError);
exports.MedusaAuthenticationError = MedusaAuthenticationError;
/**
 * MedusaPermissionErorr is raised when attempting to access a resource without permissions
 */
var MedusaPermissionError = /** @class */function (_super) {
  __extends(MedusaPermissionError, _super);
  function MedusaPermissionError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return MedusaPermissionError;
}(MedusaError);
exports.MedusaPermissionError = MedusaPermissionError;
/**
 * MedusaConnectionError is raised when the Medusa servers can't be reached.
 */
var MedusaConnectionError = /** @class */function (_super) {
  __extends(MedusaConnectionError, _super);
  function MedusaConnectionError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return MedusaConnectionError;
}(MedusaError);
exports.MedusaConnectionError = MedusaConnectionError;